import type { TOC } from '@ember/component/template-only'
import { FidgetLoadingIndicatorComponent } from '@blakeelearning/fidget/components/fidget/loading-indicator'
import { t } from 'ember-intl'
import { UiButton } from 'teacher-ui-client/components/ui-button'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import RouteTemplate from 'ember-route-template'
import { InlineAlert, AlertType, InlineAlertTitle } from 'teacher-ui-client/components/inline-alert'

export const ManageRolloverStepsStudentsImportImportingPage: TOC<unknown> = <template>
  <div class="mx-auto max-w-3xl px-2">
    <div class="mb-12">
      <InlineAlert @type={{AlertType.Information}} class="mb-8">
        <InlineAlertTitle data-test-importing-message>
          {{t "manage.rollover.steps.students.importing.alert"}}
        </InlineAlertTitle>
      </InlineAlert>

      <FidgetLoadingIndicatorComponent @show={{true}} @centered={{true}} @overlay={{false}} />

      <div class="pt-24 text-right">
        {{! a button that is never able to be used, just says importing... }}
        <UiButton @appearance={{ButtonAppearance.regular}} class="w-48 whitespace-nowrap" disabled={{true}}>
          {{t "manage.rollover.steps.students.importing.btn"}}
        </UiButton>
      </div>
    </div>
  </div>
</template>

export default RouteTemplate(ManageRolloverStepsStudentsImportImportingPage)
